import React from 'react';

export function Logo(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="54"
      fill="none"
      viewBox="0 0 54 54"
      {...props}
    >
      <g clipPath="url(#clip0_247_461)">
        <path
          fill={props.fill}
          fillRule="evenodd"
          d="M53.197 27c0 14.468-11.729 26.197-26.197 26.197S.803 41.468.803 27 12.532.803 27 .803 53.197 12.532 53.197 27zM38.095 39.714c.405.334.914.517 1.44.516v-.006a2.26 2.26 0 002.08-3.133L30.472 10.739a2.26 2.26 0 00-2.081-1.38h-.014a2.26 2.26 0 00-2.079 1.402L19.776 26.7a24.418 24.418 0 00-1.889-.074c-6.64 0-9.665 4.02-9.665 7.754 0 3.165 2.723 5.837 5.943 5.837 4.447 0 6.625-4.055 7.876-7.119l.561-1.372c3.836.86 9.39 2.952 15.494 7.988zM12.74 34.38c0-1.964 2.014-3.236 5.147-3.236h.067l-.1.242c-1.764 4.31-3.113 4.31-3.69 4.31-.802 0-1.424-.707-1.424-1.316zm19.537-3.88a36.963 36.963 0 00-7.927-3.046l4.073-9.952 5.993 14.17a47.157 47.157 0 00-2.14-1.172z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_247_461">
          <path fill="#fff" d="M0 0H54V54H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
